import React, { Component } from "react";
import { connect } from "react-redux";

import { forceLogout } from "../../../redux/actions/users";
import { getAllProducts } from "../../../redux/actions/products";

import { withRouter } from "react-router-dom";
import { formatMoney } from "../../../utils/format";

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: true,
      data: [],
      err: {},
    };

    // this.onLogout = this.onLogout.bind(this);
    // this.toggleMenu = this.toggleMenu.bind(this);
  }

  // onLogout(params) {
  //   console.log("onLogout");
  //   if (this.props.forceLogout().status === 200) {
  //     this.props.history.push("/");
  //   }
  // }

  // toggleMenu(params) {}

  componentDidMount() {
    console.log("header mounted");
    this.props
      .getAllProducts()
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
          loaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (!this.state.loaded) {
      return <div>Plase wait...</div>;
    }

    return (
      <div className="panel home-panel">
        <div className="flex justify-between items-center p-3 bg-blue-900 text-white rounded-md mb-2">
          <span className="text-lg font-semibold">Products</span>
          <div
            className="bg-blue-700 cursor-pointer p-2 text-sm rounded-md select-none"
            onClick={() => {
              console.log("add news!");
            }}
          >
            Add Items
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {this.state.data?.map((item) => {
            return (
              <div
                key={item.id}
                className="flex flex-row bg-zinc-50 gap-2 cursor-pointer p-2 text-sm rounded-md shadow-md items-center align-middle"
              >
                <div className="flex flex-0 p-2 items-center justify-center content-center">
                  {item.images[0].url !== null ? (
                    <div
                      className="avatar"
                      style={{ backgroundImage: "url(" + item.images[0].url + ")" }}
                    ></div>
                  ) : (
                    <div className="avatar">{item.images[0].fullname[0].toUpperCase()}</div>
                  )}
                </div>
                <div className="flex flex-col flex-1">
                  <span className="text-md font-light">{item.store.name}</span>
                  <span className="text-md font-semibold">{item.name}</span>
                  <span className="text-md font-semibold">{formatMoney(item.price)}</span>
                  <span>{item.description}</span>
                </div>
                <div className="flex-0 flex flex-row gap-2 p-3">
                  <div className="text-sm p-2 bg-orange-700 text-white rounded cursor-pointer hover:bg-orange-900 min-w-16 text-center">
                    Edit
                  </div>
                  <div className="text-sm p-2 bg-blue-800 text-white rounded cursor-pointer hover:bg-blue-900 min-w-16 text-center">
                    Preview
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    forceLogout: (data) => dispatch(forceLogout(data)),
    getAllProducts: (data) => dispatch(getAllProducts(data)),
  };
}

const mapStateToProps = (state) => ({
  ...state,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Products));
